import React, { FC, useContext } from 'react';
import { Field, Form } from 'react-final-form';
import { Grid } from '@mui/material';
import TextFieldAdapter from '../FinalFormAdapters/TextFieldAdapter';
import {
  composeValidators,
  validateRequired,
  validateTel,
} from '../../helpers/ValidatorHelper';
import NumberFormatTelAdapter from '../NumberFormat/NumberFormatTelAdapter';
import { feedbackSend } from '../../api/feedback';
import useClosableSnackbar from '../../hooks/useClosableSnackbar';
import AccountContext from '../../context/AccountContext';

interface Props {
  formRef: React.RefObject<HTMLFormElement>;
  onSubmitted: () => void;
}

const FeedbackForm: FC<Props> = ({ formRef, onSubmitted }) => {
  const { showSnackbar } = useClosableSnackbar();
  const { accountResponse } = useContext(AccountContext);

  return (
    <Form
      initialValues={{
        phone: accountResponse?.phone.substring(1, 11),
        name: accountResponse?.displayName,
      }}
      onSubmit={async ({ name, phone, message }) => {
        try {
          await feedbackSend(name, phone, message);
          showSnackbar('Сообщение отправлено.');
          onSubmitted();
        } catch (e) {
          showSnackbar('Ошибка отправки сообщения. Попробуйте позже.');
        }
      }}
      render={({ handleSubmit }) => (
        <form onSubmit={handleSubmit} ref={formRef}>
          <Grid container spacing={3}>
            <Grid xs={12} item>
              <Field
                fullWidth
                label="Фамилия Имя Отчество"
                name="name"
                validate={validateRequired}
                component={TextFieldAdapter}
              />
            </Grid>
            <Grid xs={12} item>
              <Field
                fullWidth
                label="Телефон"
                name="phone"
                validate={composeValidators(validateTel, validateRequired)}
                component={NumberFormatTelAdapter}
                disabled
              />
            </Grid>
            <Grid xs={12} item>
              <Field
                fullWidth
                label="Введите сюда своё сообщение для нас"
                name="message"
                validate={validateRequired}
                component={TextFieldAdapter}
                multiline
              />
            </Grid>
          </Grid>
        </form>
      )}
    />
  );
};

export default FeedbackForm;
